import React from "react";

const Ads = () => {
    return (
        <div style={{ margin: "1.5vh 0vh 50vh" }}>
            <img
                src="https://tpc.googlesyndication.com/simgad/12420666613166605282?"
                alt="ads"
            />
        </div>
    );
};

export default Ads;
